export default __webpack_public_path__ + "static/media/Rectangle.8b327877.svg";